import {ActionList} from '@primer/react'

import type {RefSelectorFooterProps} from './RefSelector'
import styles from './RefSelectorFooter.module.css'

export function RefSelectorFooter({text, onClick, href, className}: RefSelectorFooterProps) {
  const isLinkItem = !!href
  const innerContent = <div className={className}>{text}</div>

  return isLinkItem ? (
    <ActionList.LinkItem role="link" href={href} onClick={() => onClick?.()} className={styles.actionListItem}>
      {innerContent}
    </ActionList.LinkItem>
  ) : (
    <ActionList.Item role="button" onSelect={() => onClick?.()} className={styles.actionListItem}>
      {innerContent}
    </ActionList.Item>
  )
}
